import { useToken } from "@gluestack-style/react";
import { Box, Button, Text, View } from "components/ui";
import { ChevronLeft, ChevronRight } from "lucide-react-native";
import React from "react";
import { Dimensions, Platform, ScrollView } from "react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import RNCarousel from "react-native-reanimated-carousel";

interface CardCarouselProps {
	children: any;
	shownSlideNumber?: number;
	hideArrows?: boolean;
	infinite?: boolean;
	showDots?: boolean;
}
const CardCarousel = (props: CardCarouselProps) => {
	const isMobile = useIsMobile();
	const carouselRef: any = React.useRef(null);

	// Destructure props with defaults
	const { children, shownSlideNumber, hideArrows = false, infinite = false, showDots = true } = props;

	const CustomButtonGroupAsArrows = ({ next, previous }: any) => {
		const resolvedDarkteal = useToken("colors", "darkteal");
		const buttonSize = isMobile ? 32 : 40;
		const gapSize = isMobile ? 320 : 120;

		return (
			<Box justifyContent="center" gap={gapSize} flexDirection="row" marginTop={isMobile ? 40 : 64}>
				<Button padding={0} borderRadius={6} borderWidth={1} borderColor={"$darkteal"} w={buttonSize} h={buttonSize} onPress={previous} $hover-bgColor={"#E1E9F0"}>
					<ChevronLeft color={resolvedDarkteal} size={isMobile ? 18 : 24} />
				</Button>
				<Button padding={0} borderRadius={6} borderWidth={1} borderColor={"$darkteal"} w={buttonSize} h={buttonSize} onPress={next} $hover-bgColor={"#E1E9F0"}>
					<ChevronRight color={resolvedDarkteal} size={isMobile ? 18 : 24} />
				</Button>
			</Box>
		);
	};
	const CustomDot = ({ onClick, active, index, carouselState }: any) => {
		const { currentSlide } = carouselState;
		const resolvedDarkteal = useToken("colors", "darkteal");
		const resolvedWhite = useToken("colors", "basicwhite");

		if (Platform.OS === "web") {
			return (
				<Box bottom={16} marginHorizontal={6} h={"$full"} justifyContent="center">
					<Box borderRadius={"$full"} borderWidth={2} backgroundColor={active ? "$darkteal" : "$basicwhite"} w={12} h={12} />
				</Box>
			);
		}

		return (
			<Box bottom={16} marginHorizontal={6} h={"$full"} justifyContent="center">
				<Box borderRadius={"$full"} borderWidth={2} backgroundColor={active ? resolvedDarkteal : resolvedWhite} w={10} h={10} />
			</Box>
		);
	};
	if (isMobile) {
		const { width, height } = Dimensions.get("window");
		return (
			<Box marginBottom={24} paddingHorizontal={16} position="relative" width="100%">
				<Carousel
					ref={carouselRef}
					additionalTransfrom={0}
					arrows={false}
					autoPlaySpeed={3000}
					centerMode={false}
					className=""
					containerClass="container-padding-bottom"
					customButtonGroup={!hideArrows ? <CustomButtonGroupAsArrows /> : undefined}
					customDot={<CustomDot />}
					dotListClass=""
					draggable
					focusOnSelect={false}
					infinite={infinite}
					itemClass=""
					keyBoardControl
					minimumTouchDrag={80}
					pauseOnHover
					renderArrowsWhenDisabled={false}
					renderButtonGroupOutside={!hideArrows}
					renderDotsOutside
					responsive={{
						mobile: {
							breakpoint: {
								max: 464,
								min: 0,
							},
							items: 1,
							partialVisibilityGutter: 20,
						},
						tablet: {
							breakpoint: {
								max: 1024,
								min: 464,
							},
							items: 2,
							partialVisibilityGutter: 30,
						},
					}}
					rewind={false}
					rewindWithAnimation={false}
					rtl={false}
					shouldResetAutoplay
					showDots={showDots}
					sliderClass=""
					slidesToSlide={1}
					swipeable
				>
					{children}
				</Carousel>
			</Box>
		);
	}
	return (
		<div
			style={{
				position: "relative",
				width: "100%",
			}}
		>
			<Carousel
				ref={carouselRef}
				additionalTransfrom={0}
				arrows={false}
				autoPlaySpeed={3000}
				centerMode={false}
				className=""
				// containerClass="container-padding-bottom"
				customButtonGroup={!hideArrows ? <CustomButtonGroupAsArrows /> : undefined}
				customDot={<CustomDot />}
				dotListClass=""
				draggable
				focusOnSelect={false}
				infinite={infinite}
				itemClass=""
				keyBoardControl
				minimumTouchDrag={80}
				pauseOnHover
				renderArrowsWhenDisabled={false}
				renderButtonGroupOutside={!hideArrows}
				renderDotsOutside
				responsive={{
					desktop: {
						breakpoint: {
							max: 3000,
							min: 1024,
						},
						items: shownSlideNumber ? shownSlideNumber : 3,
						partialVisibilityGutter: 40,
					},
					mobile: {
						breakpoint: {
							max: 464,
							min: 0,
						},
						items: 1,
						partialVisibilityGutter: 20,
					},
					tablet: {
						breakpoint: {
							max: 1024,
							min: 464,
						},
						items: 2,
						partialVisibilityGutter: 30,
					},
				}}
				rewind={false}
				rewindWithAnimation={false}
				rtl={false}
				shouldResetAutoplay
				showDots={showDots}
				sliderClass=""
				slidesToSlide={1}
				swipeable
			>
				{children}
			</Carousel>
		</div>
	);
};

export default CardCarousel;
